let inject = ['$q','$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
class ResponseService {
  constructor ($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
  }
  
  getResponse(id){
    
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + '/order/get-pay-info?idPedido=' + id,
        cache : true
      }).then((response) => {
        resolve(response);
      }, (reason) => {
        reject(reason);
      });
    });
  }
}

ResponseService.$inject = inject;

export default ResponseService;



/** WEBPACK FOOTER **
 ** ./www/components/response/response.service.js
 **/